import Vue from 'vue'
import VTodayNew  from './todaynew'

export default VTodayNew




// WEBPACK FOOTER //
// ./src/components/index/mobile/todaynew1/index.js